// Calcul de la disponibilité d'un employé pour une date ISO (YYYY-MM-DD)

export const localIsoDate = (d = new Date()) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

const within = (d, start, end) => !(start && d < start) && !(end && d > end);

// Périodes d'indisponibilité, ancien format (statut unique) inclus
export const getPeriods = (emp) => {
  const periods = [...(emp?.unavailability_periods || [])];
  const mode = (emp?.availability_mode || "AVAILABLE").toUpperCase();
  if (mode === "FULL" || mode === "ON_LEAVE") {
    periods.push({
      id: "legacy",
      type: mode,
      start_date: emp.availability_start_date || "",
      end_date: emp.availability_end_date || "",
    });
  }
  return periods;
};

export const getUnavailabilityOn = (emp, d) =>
  getPeriods(emp).find((p) => within(d, p.start_date, p.end_date)) || null;

export const getQuotaOn = (emp, d) => {
  const mode = (emp?.availability_mode || "AVAILABLE").toUpperCase();
  const quota = emp?.daily_quota;
  if (mode !== "AVAILABLE" || !quota || quota <= 0) return null;
  return within(d, emp.availability_start_date, emp.availability_end_date) ? quota : null;
};

export const fmtShort = (d) => (d ? d.split("-").reverse().slice(0, 2).join("/") : "…");
